import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { AppBar } from '@material-ui/core';
import { Mobile, Default } from 'components/Media';
import PromoBanner, { CHANNELS, PLACEMENTS } from 'components/Promos/Banner';
import PrimoTransitionBanner from 'components/ContentfulFields/PrimoTransitionBanner';
import Navigation from './Navigation';
import Contacts from './Contacts';
import Collapse from './Collapse';
import styles from './styles/water-regional.scss';

class Header extends PureComponent {
  state = {
    drawerIsOpen: false,
    drawersContent: null,
    drawersActiveTabId: null,
  };

  openCollapse = (id, content) => {
    this.setState((prevState) => ({
      drawerIsOpen:
        id !== prevState.drawersActiveTabId ? true : !prevState.drawerIsOpen,
      drawersContent: content,
      drawersActiveTabId: id !== prevState.drawersActiveTabId ? id : null,
    }));
  };

  closeCollapse = () => {
    this.setState({
      drawerIsOpen: false,
      drawersContent: null,
      drawersActiveTabId: null,
    });
  };

  render() {
    const {
      state: { drawerIsOpen, drawersContent, drawersActiveTabId },
      props: { document },
    } = this;

    const testMedia = false;

    const navigation = (
      <Navigation
        document={document}
        openCollapse={this.openCollapse}
        closeCollapse={this.closeCollapse}
        activeDrawer={drawersActiveTabId}
        drawerIsOpen={drawerIsOpen}
        changeHeight={this.changeHeight}
      />
    );

    const collapse = (
      <Collapse
        open={drawerIsOpen}
        content={drawersContent}
        onClose={this.closeCollapse}
      />
    );

    const MobileHeader = (
      <Fragment>
        {testMedia && <div className={styles.testMedia}>Test Media: </div>}
        <PrimoTransitionBanner />
        <Contacts
          fields={document && document.fields.content}
          openCollapse={this.openCollapse}
        />
        <PromoBanner placement={PLACEMENTS.aboveLogo} channel={CHANNELS.ss} />
        <AppBar className={styles.header} position="sticky">
          {navigation}
          {collapse}
        </AppBar>
      </Fragment>
    );

    return (
      <Fragment>
        <Default>
          <AppBar elevation={1} className={styles.header} position="sticky">
            {testMedia && (
              <div className={styles.testMedia}>Desktop Media: </div>
            )}
            <PrimoTransitionBanner />
            <Contacts
              fields={document && document.fields.content}
              openCollapse={this.openCollapse}
            />
            <PromoBanner placement={PLACEMENTS.aboveLogo} />
            {navigation}
            {collapse}
          </AppBar>
        </Default>
        <Mobile>{MobileHeader}</Mobile>
      </Fragment>
    );
  }
}

Header.propTypes = {
  document: PropTypes.object,
};

export default withRouter(Header);
